import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=5b83af8e&scoped=true"
import script from "./NewsList.vue?vue&type=script&lang=js"
export * from "./NewsList.vue?vue&type=script&lang=js"
import style0 from "./NewsList.vue?vue&type=style&index=0&id=5b83af8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83af8e",
  null
  
)

export default component.exports